module.exports = {
      id: "success-circle-usage",
      viewBox: "0 0 89 88",
      url: __webpack_public_path__ + "svg-sprite.svg#success-circle",
      toString: function () {
        return this.url;
      }
    }